import { render } from "./BackToStudentUiButton.vue?vue&type=template&id=4781da0c&scoped=true"
import script from "./BackToStudentUiButton.vue?vue&type=script&lang=js"
export * from "./BackToStudentUiButton.vue?vue&type=script&lang=js"

import "./BackToStudentUiButton.vue?vue&type=style&index=0&id=4781da0c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4781da0c"]])

export default __exports__